import { pageSelectedPacks as onlinePageSelectedPacks } from '../../../services/modules/product-colors-packs/product-colors-packs.repository';
import { PageSelectedPacksParams } from '../../../services/modules/product-colors-packs/product-colors-packs.types';
import { getOfflineProductColorPacksBasedOnAvailability } from '../database/offlineDatabase/types/offlineDatabaseProductColor.types';
import { offlinePacksRepository } from '../repositories/offlinePacks.repository';
import { offlineProductColorsRepository } from '../repositories/offlineProductColors.repository';
import { offlineSizesRepository } from '../repositories/offlineSizes.repository';
import { OfflinePacksTransformers } from '../transformers/OfflineDatabasePack.transformers';
import { createApiSauceResponse } from '../utils/createApiSauceResponse.util';

export const pageSelectedPacks: typeof onlinePageSelectedPacks = async ({
  ids,
  skip,
  limit,
  packName,
  productColorId,
  productColorAvailability,
}: PageSelectedPacksParams) => {
  const offlineProductColor = await offlineProductColorsRepository.getById(productColorId);

  const productColorPacks = offlineProductColor
    ? getOfflineProductColorPacksBasedOnAvailability(offlineProductColor, productColorAvailability)
    : undefined;

  if (!productColorPacks?.length) {
    console.error('[pageSelectedPacks] not found packs or product color', {
      productColorId,
      productColorAvailability,
    });

    return createApiSauceResponse({
      ok: true,
      data: {
        data: [],
        count: 0,
      },
    });
  }

  const packIdsOfProductColor = productColorPacks.map((pack) => pack.packId);

  const idsFilteredToProductColor = ids
    ? ids.filter((id) => packIdsOfProductColor.includes(id))
    : packIdsOfProductColor;

  const pagePacks = await offlinePacksRepository.page({
    skip,
    limit,
    query: packName,
    ids: idsFilteredToProductColor,
  });

  const packs = pagePacks.data;

  const sizeIdsToFetch = packs.flatMap((pack) => pack.quantitiesBySize.map((size) => size.sizeId));
  const sizes = await offlineSizesRepository.findByIds(sizeIdsToFetch);

  const packsAsOutput = packs.map((pack) =>
    OfflinePacksTransformers.toPageSelectedPacksData({
      offlinePack: pack,
      offlineSizes: sizes,
      offlineProductColorPack: productColorPacks.find(
        (productColorPack) => productColorPack.packId === pack.id,
      )!,
    }),
  );

  return createApiSauceResponse({
    ok: true,
    data: {
      data: packsAsOutput,
      count: pagePacks.count,
    },
  });
};

export const productColorPacksRepositoryOfflineAdapters = {
  pageSelectedPacks,
};
